package system.network

import assets.*
import com.github.quillraven.fleks.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.view.*
import component.*
import kotlinx.coroutines.channels.*
import models.PlayerData
import utils.PlayerBuilder.buildPlayerContainer

class NetworkOtherPlayersSpawnSystem(
    private val physicWorld: org.jbox2d.dynamics.World = World.inject(),
    private val camera: Camera = World.inject()
) : IntervalSystem() {

    private val playersToRespawn = Channel<PlayerData>(capacity = 5)

    fun respawnPlayer(player: PlayerData) {
        playersToRespawn.trySend(player)
    }

    override fun onTick() {
        val newPlayer: PlayerData? = playersToRespawn.tryReceive().getOrNull()
        if (newPlayer != null) {
            createPlayer(newPlayer)
        }
    }

    private fun createPlayer(newPlayer: PlayerData) {
        val posX = newPlayer.x
        val posY = newPlayer.y

        val sprite = Sprite().apply {
            scale = 2.0
            position(-5, -5)
        }

        val view = camera.buildPlayerContainer(
            posX * physicWorld.customScale,
            posY * physicWorld.customScale,
            sprite,
            physicWorld
        )

        world.entity {
            it += SpriteAnimationComponent(animationPrefix = "ninja-frog").apply {
                nextAnimation = PlayerAnimationTypes.IDLE_RIGHT.name
                this.sprite = sprite
            }
            it += PhysicComponent(
                body = view.body!!,
                vXmax = 10f
            )
            it += OtherPlayerComponent(newPlayer.id).apply {
                direction = BodyDirection.RIGHT
            }

            it += StateComponent().apply {
                state = StateComponent.STATE_FALLING
            }

            it += NetworkInputDataComponent(newPlayer.id)

            it += PhysicSnapshotStateComponent()
        }
    }
}
